module.exports = __webpack_public_path__ + "img/熊猫-1.4743bd85.jpg";